export default () => {
  let targets = document.querySelectorAll('.form');
  
  if (targets.length) {
    targets.forEach((form) => {
      let formContent = form.querySelector('.form__content'),
          success = form.querySelector('.form__success'),
          error = form.querySelector('.form__error');

      formContent.classList.remove('fade-off');
      // form.find('.form__nojs').remove();

      form.addEventListener('submit', (e) => {
        let formData = new FormData(form);
        e.preventDefault();

        if (
          !formData.get('firstname') 
          || !formData.get('lastname') 
          || !formData.get('firstname') 
          || !formData.get('firstname')
        ) {
          error.classList.remove('fade-off');
          error.innerHTML = 'Fill all required fields';
          setTimeout(function () {
            error.classList.add('fade-off');
          }, 4000);
          return
        } else {
          error.classList.add('fade-off');
        }

        fetch(form.getAttribute('action'), {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
          },
          body: formData
        })
          .then(formSuccess)
          .catch(formError);
      }); 

      // Success function
      function formSuccess(response) {
        response.json().then((response) => {
          if (response.result) {
            formContent.classList.add('fade-off');
            success.classList.remove('fade-off');
            success.innerHTML = response.msg;
          } else {
            error.classList.remove('fade-off');
            error.innerHTML = response.msg;
          }
        });
      }
  
      // fail function
      function formError(data) {
        error.classList.remove('fade-off');
        error.innerHTML = data.responseText ? data.responseText : 'Something went wrong. Try again or contact us <a href="tel:18006796482" class="link">1.800.679.6482</a>.';
        setTimeout(function () {
          error.classList.add('fade-off');
        }, 4000);
      }
    });

  }
}